import { z } from 'zod';
import { EmptyValidationMessage, FormFieldSchema, mapDropDown } from '@ninja/utilities';
import { useAppPlatformContextOptions } from '../../../../../contexts/app';
import { selectMembers, selectPlans, useAppInitStore, useQuoteStore } from '../../../../../stores';
import { useMemberOccupations, useSponsorOccupations } from '../../../../app-init-data';
import { prepareFieldError } from '../../../members/members-form/helpers/add-field-error';
import { InvestorImpactEnum } from '../../../quote-list/server/map-quotes';
import { DocumentsForm } from '../types';

const FIELD_NAME = 'occupationId';

export const useOccupationField = () => {
	const { translate: t } = useAppPlatformContextOptions();
	const journeyDetails = useQuoteStore(selectMembers);
	const plans = useAppInitStore(selectPlans);
	const selectedPlanId = journeyDetails?.planId;
	const selectedPlan = plans?.find((p) => p.id === selectedPlanId);
	const isInvestorPartnerOnly = selectedPlan?.isInvestorPartnerOnly === InvestorImpactEnum.ImpactedButVisible;

	const { occupations } = useMemberOccupations();
	const { sponsorOccupations } = useSponsorOccupations();

	const getField = (memberId: string): FormFieldSchema<DocumentsForm> =>
		mapDropDown({
			field: `${memberId}.${FIELD_NAME}`,
			label: t('documents:fields.occupation.label'),
			options: isInvestorPartnerOnly ? sponsorOccupations : occupations,
			labelKey: 'name',
			valueKey: 'id',
			isSearchable: !isInvestorPartnerOnly,
			initialOptionCount: 50,
		});

	const getValidation = () => z.number({ required_error: EmptyValidationMessage });

	const validate = (value?: number, addFieldError?: ReturnType<typeof prepareFieldError>) => {
		if (!value) {
			addFieldError?.({ field: FIELD_NAME, message: EmptyValidationMessage });
		}
	};

	return {
		getField,
		getValidation,
		validate,
	};
};
